import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {CdkDragDrop, copyArrayItem, transferArrayItem} from '@angular/cdk/drag-drop';
import {MatDialog} from '@angular/material/dialog';
import {BehaviorSubject} from 'rxjs';
import {BlockForm, BlockTypeEnum, FieldConfigName, FieldType} from '../../models';
import {Constants} from '../common/constants';
import {DmConfirmDialogComponent} from '../shared/confirm-dialog/confirm-dialog.component';
import {FormulaireService} from '../../../../services/formulaire/formulaire.service';
import {DmBlockModalComponent} from '../shared/block-modal/dm-block-modal.component';


@Component({
  selector: 'app-dm-form-block',
  templateUrl: './form-block.component.html',
  styleUrls: ['./form-block.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class FormBlockComponent implements OnInit, OnChanges {
  @Input() itemBlockObj: BlockForm;
  @Input() indexBlock: number;
  @Input() lastIndexBlock: number;
  @Output() moveUpBlock = new EventEmitter<any>();
  @Output() moveDownBlock = new EventEmitter<any>();
  @Output() removeBlock = new EventEmitter<any>();
  @Input() administratifBlockExist: boolean;
  @Output() closeDialog = new EventEmitter<any>();

  fieldType = FieldType;
  constants: any = Constants;
  blockItem$ = new BehaviorSubject<BlockForm>({});
  blockTypeEnum = BlockTypeEnum;

  constructor(public dialog: MatDialog,
              private formSvc: FormulaireService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    /**
     * calcul position et reconstruction des fields pour ce bloc
     */
    if (changes.itemBlockObj?.currentValue) {
      this.itemBlockObj.position = this.indexBlock + 1;
      this.formSvc.constructFieldsConfig(this.itemBlockObj);
      this.blockItem$.next(this.itemBlockObj);
    }
  }

  ngOnInit(): void {
  }

  /**
   * Recalcul des positions des champs
   * @param {FieldConfigName} f : le champ
   * @param {number} idx : indice du champ dans le bloc
   * @description l'attribut id c est celui du default field,
   * il sert quand on copie des champs d un block a un autre pour calculer le defaultfield.
   */
  calculateFieldPosition(f: FieldConfigName, idx: number) {
    return <FieldConfigName>{
      id: f.id,
      defaultFieldId: f.id,
      options: f.options,
      position: idx + 1,
      isInBlockAdmin: (this.itemBlockObj.type === BlockTypeEnum.Administratif)
    };
  }

  drop(event: CdkDragDrop<Array<FieldConfigName>, any>): void {
    if (event.previousContainer.id === 'default_fields_list_id') {
      this.onCopyArrayItem(event);
    } else {
      this.onMoveItemInArray(event);
    }
    this.itemBlockObj.fields = this.itemBlockObj.fields
      .map((f: FieldConfigName, k: number) => this.calculateFieldPosition(f, k));
  }

  /**
   * Copie "profonde" de la config champ FieldConfigName
   * @param data
   * @private
   */
  private copyDeepConfig(data) {
    return JSON.parse(JSON.stringify(data));
  }

  /**
   * Drag & Drop d'un champ sur le formulaire lui-même (reste à droite)
   * @param event
   */
  onMoveItemInArray(event: CdkDragDrop<FieldConfigName[]>) {
    transferArrayItem(
      event.previousContainer.data,
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
  }

  /**
   * Drag & Drop d'un élément des champs disponibles (gauche) vers le formulaire
   * Deep copy pour la config pour ne pas garder une référence sur le prochain champ de même type mis de gauche à droite
   * @param event
   */
  onCopyArrayItem(event: CdkDragDrop<FieldConfigName[]>) {
    const configField = this.copyDeepConfig(event.previousContainer.data);
    const copiedFieldOptions = event.previousContainer.data[event.previousIndex].options;
    /**
     * Le type de fichier accepté par defaut.
     * L'attribut accept du champ fichier ne dois jamais etre vide por raison sécurité.
     */
    if (copiedFieldOptions.controlType === 'file') {
      copiedFieldOptions.acceptedTypeFile = 'image/*';
    }
    copyArrayItem(
      configField,
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
  }

  updatedControl(data: any): void {
    this.itemBlockObj.fields.splice(data.index, 1, data.control);
  }

  deleteControl(indexControl: number): void {
    this.itemBlockObj.fields.splice(indexControl, 1);
  }

  openBlockDialog(item): void {
    const dialogRef = this.dialog.open(DmBlockModalComponent, {
      width: '680px',
      data: {
        form: item,
        is_block: true,
        administratifBlockExist: this.administratifBlockExist,
        buttonText: {
          ok: 'Fermer',
        },
      },
    });
    dialogRef.updatePosition({top: '100px'});
    dialogRef.afterClosed().subscribe(
      data => {
        this.closeDialog.emit();
      }
    );
  }

  editBlock(itemBlockObj: BlockForm) {
    this.openBlockDialog(itemBlockObj);
  }

  deleteBlockDialog(blockIndex: number): void {
    const dialogRef = this.dialog.open(DmConfirmDialogComponent, {
      width: '450px',
      data: {
        message: this.constants.messages.waringMessage
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.removeBlock.emit(blockIndex);
      }
    });
  }

  onRemoveBlock(indexBlock: number) {
    this.deleteBlockDialog(indexBlock);
  }

  onMoveUpBlock(itemBlockObj: BlockForm) {
    this.moveUpBlock.emit(itemBlockObj);
  }

  onMoveDownBlock(itemBlockObj: BlockForm) {
    this.moveDownBlock.emit(itemBlockObj);
  }
}
